import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import { SideBar } from '../sidebar/siderbar';

@Component({
  selector: 'app-appli-side-bar',
  templateUrl: './appli-side-bar.component.html',
  styleUrls: ['./appli-side-bar.component.scss']
})
export class AppliSideBarComponent implements OnInit, AfterViewInit {
  @Input() sidebars: SideBar<string, string>[];
  @Input() focusIndex: number;
  @Output() clickEventIndex = new EventEmitter<number>();
  @Output() allFocusReset = new EventEmitter();
  @Output() setFocus = new EventEmitter<number>();
  constructor(private el: ElementRef) {}
  ngOnInit() {}

  click(index: number) {
    this.clickEventIndex.emit(index);
  }
  focus(i: number) {
    this.sidebars.forEach(d => (d.focused = false));
    this.sidebars[i].focused = true;
  }
  blur() {
    this.allFocusReset.emit();
  }

  ngAfterViewInit(): void {
    const focused_index = this.sidebars.findIndex(d => d.focused);
    this.el.nativeElement.querySelectorAll('li')[focused_index].focus();
  }
}
